module.exports = __webpack_public_path__ + "static/media/hyperlink-2.33730741.svg";